// current user invitations to circles
import { combineReducers } from 'redux';
import caregiver from './caregiver';
import familyMember from './familyMember';
import guardian from './guardian';

export default combineReducers({
  caregiver,
  familyMember,
  guardian,
});



// WEBPACK FOOTER //
// ./src/redux/invitations/index.js